export default function MailIcon() {
	return (
		<svg
			width="24"
			height="24"
			viewBox="0 0 24 24"
			fill="none"
			xmlns="http://www.w3.org/2000/svg"
		>
			<path
				d="M2.6078 5.64824C1.99976 6.93577 1.99976 8.77405 1.99976 12C1.99976 15.7497 1.99976 17.6246 2.95467 18.9389C3.26307 19.3634 3.63636 19.7367 4.06083 20.0451C5.37516 21 7.25002 21 10.9998 21H12.9998C16.7495 21 18.6244 21 19.9387 20.0451C20.3632 19.7367 20.7364 19.3634 21.0448 18.9389C21.9998 17.6246 21.9998 15.7497 21.9998 12C21.9998 8.75125 21.9998 6.90985 21.3787 5.62103M2.6078 5.64824C2.70653 5.4392 2.82128 5.24467 2.95467 5.06107C3.26307 4.6366 3.63636 4.26331 4.06083 3.95491C5.37516 3 7.25002 3 10.9998 3H12.9998C16.7495 3 18.6244 3 19.9387 3.95491C20.3632 4.26331 20.7364 4.6366 21.0448 5.06107C21.1724 5.23667 21.283 5.42228 21.3787 5.62103M2.6078 5.64824L2.99976 6L4.92869 7.92893C8.26202 11.2623 9.92869 12.9289 11.9998 12.9289C14.0708 12.9289 15.7375 11.2623 19.0708 7.92894L20.9998 6L21.3787 5.62103"
				stroke="#2EDBCA"
				strokeWidth="1.5"
			/>
		</svg>
	);
}
